import type { Pair } from '../messages';

/** Global search: the field, the three result groups and the two empty states. */
export const search = {
  'search.subtitle': ['Ваши находки, открытые подборки и люди', 'Your links, public collections and people'],
  'search.aria': ['Общий поиск', 'Search everything'],
  'search.placeholder': ['Название подборки, профиль или ваша ссылка…', 'A collection title, a profile or one of your links…'],
  'search.emptyTitle': ['Что ищем?', 'What are we looking for?'],
  'search.emptyBody': [
    'Достаточно пары букв — поиск по названию, описанию и автору.',
    'Two letters are enough — titles, descriptions and authors are all searched.',
  ],
  'search.nothingBody': [
    'По запросу «{term}» нет ни ваших ссылок, ни открытых подборок, ни профилей.',
    'Nothing for “{term}” — no links of yours, no public collections, no profiles.',
  ],
  'search.addThisLink': ['Добавить эту ссылку в библиотеку', 'Add this link to your library'],
  'search.yourLinks': ['Ваши ссылки', 'Your links'],
  'search.people': ['Люди', 'People'],
} satisfies Record<string, Pair>;
